var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var IdentityValidIcon = function (props) { return (_jsx("svg", __assign({ width: "19", height: "22", viewBox: "0 0 19 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M9 13.062V21H3.47932e-08C-0.00010582 19.8649 0.24133 18.7428 0.708267 17.7083C1.1752 16.6737 1.85695 15.7503 2.70822 14.9995C3.55948 14.2487 4.56078 13.6876 5.64557 13.3536C6.73037 13.0195 7.87384 12.9201 9 13.062ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM13.793 18.914L17.328 15.379L18.743 16.793L13.793 21.743L10.257 18.207L11.672 16.793L13.792 18.914H13.793Z", fill: "currentColor" }) }))); };
